<template>
    <a-card v-if="pageLoading">
      <a-spin
        tip="Your document is being processed, do not leave this page!"
        :spinning="pageLoading"
      ></a-spin>
    </a-card>
    <div v-else>
      <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'">
        <a-row :gutter="8">
          <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
            <a-card :loading="pageLoading" class="margin-bottom">
              <div slot="title">Credit Card Claim Ticket Manifest</div>
              <div class="m-card-body">
                <ul class="m-list-wrapper bordered">
                  <li>
                    <span class="m-list-title" for>No. Transaksi</span>
                    <span class="m-list-desc">{{ data.header.no_klaim }}</span>
                  </li>
                  <li>
                    <span class="m-list-title" for>Created Date</span>
                    <span class="m-list-desc">{{data.header.tanggal_buat
                    }}</span>
                  </li>
                  <li>
                    <span class="m-list-title" for>User Creator</span>
                    <span class="m-list-desc">{{
                      data.header.user_pelapor
                    }}</span>
                  </li>
                  <li>
                    <span class="m-list-title" for>User CC</span>
                    <span class="m-list-desc">{{
                      data.header.user_cc
                    }}</span>
                  </li>
                  <li>
                    <span class="m-list-title" for>Total</span>
                    <span class="m-list-desc">{{
                      formatRupiah(data.header.total_klaim)
                    }}</span>
                  </li>
                  <li>
                    <span class="m-list-title" for>Note</span>
                    <span class="m-list-desc">{{
                      data.header.note
                    }}</span>
                  </li>
                </ul>
              </div>
            </a-card>
            <a-collapse class="margin-top" activeKey="1">
              <a-collapse activeKey="1">
                <a-collapse-panel key="1">
                  <h4 slot="header" class="margin-remove">Total Amount of Use</h4>
                  <a-card :loading="pageLoading">
                    <ul class="m-list-wrapper">
                      <li>
                        <a-input-search
                          v-model="search"
                          style="width: 50%"
                          placeholder="Quick Search"
                          :change="searching"
                          allowClear
                        />
                      </li>
                    </ul>
                  </a-card>
                  <a-table
                    :columns="columns"
                    :dataSource="tableData"
                    :pagination="pagination"
                    size="small"
                    :scroll="{ x: 800 }"
                    bordered
                  >
                    <span slot="deskripsi" slot-scope="item">
                      {{item.description}}
                    </span>
                    <span slot="no_sppd" slot-scope="item">
                      {{ item.no_sppd }}
                    </span>
                    <span slot="end_user_nm" slot-scope="item">
                      {{ item.end_user_nm }}
                    </span>
                    <span slot="kredit" slot-scope="kredit">
                      <CurrencyJustified
                        v-if="kredit.val"
                        :currencyValue="kredit.curr"
                        :valueNumber="kredit.val"
                      />
                      <div v-else style="text-align: center; width: 100%">-</div>
                    </span>
                    <template slot="footer">
                      <a-row type="flex">
                        <a-col :span="5" :order="1" class="m-text-align left"
                          >Total Credit</a-col
                        >
                        <a-col
                          :span="5"
                          :order="2"
                          class="m-text-align left m-text-bold"
                          >{{ formatCurrency(currency, data.header.total_klaim) }}</a-col
                        >
                      </a-row>
                    </template>
                    <template slot="document" slot-scope="index, item">
                      <a-button v-if="item.lampiran" @click="viewlampiranDoc(item.lampiran_path)" 
                      class="margin-top" type="dashed">View Document</a-button>
                    </template>
                  </a-table>
                </a-collapse-panel>
              </a-collapse>
            </a-collapse>
            <a-collapse class="margin-top" activeKey="1">
              <a-collapse-panel key="1">
                <div
                  class="m-display-flex space-between align-middle"
                  slot="header"
                >
                  <h4 class="margin-remove">Status</h4>
                  <div>
                    <Status :status="data.last_status" />
                    <a-button
                      @click="historyToggle"
                      type="default"
                      size="small"
                      class="margin-right-small"
                    >
                      History
                      <a-icon type="undo" />
                    </a-button>
                  </div>
                </div>
                <a-timeline class="m-timeline">
                  <a-timeline-item color="green">
                    <div class="m-timeline-title">
                      Pembuat - {{ data.user_pembuat.tlc }}
                    </div>
                    <div class="m-timeline-body">
                      <h4 class="margin-remove">
                        {{ data.user_pembuat.tanggal }}
                      </h4>
                    </div>
                    <div class="m-timeline-footer">
                      <a-tag color="green">{{ data.user_pembuat.status }}</a-tag>
                    </div>
                  </a-timeline-item>
                  <a-timeline-item
                    v-for="workflow in data.status"
                    :key="workflow.step_no"
                    :color="
                      workflow.status === 'On Process' ||
                      workflow.status === 'Delivered'
                        ? 'red'
                        : workflow.status === 'Waiting'
                        ? 'grey'
                        : 'green'
                    "
                  >
                    <div class="m-timeline-title">
                      {{
                        workflow.actor === null ? workflow.jenis : workflow.actor
                      }}
                      {{ workflow.tlc ? " - " + workflow.tlc : "" }}
                    </div>
                    <div class="m-timeline-body">
                      <h4
                        class="margin-remove"
                        v-if="workflow.tanggal_aksi !== null"
                      >
                        {{ workflow.tanggal_aksi }}
                      </h4>
                      <span class="m-text-small" v-if="workflow.remark">{{
                        workflow.remark
                      }}</span>
                      <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                    </div>
                    <div class="m-timeline-footer">
                      <Status :status="workflow.status" />
                    </div>
                  </a-timeline-item>
                </a-timeline>
              </a-collapse-panel>
            </a-collapse>
            <a-card
              class="margin-top"
              :loading="pageLoading"
              v-if="data.aksi.length > 0"
            >
              <div slot="title">Manifest Actions</div>
  
              <a-form :form="form">
                <a-form-item label="Note">
                  <a-textarea
                    placeholder="Write the note here ... "
                    :rows="4"
                    v-decorator="['catatan']"
                  />
                </a-form-item>
                <a-form-item label="Aksi">
                  <a-select
                    showSearch
                    v-decorator="['aksi', { rules: [{ required: true }] }]"
                  >
                    <a-select-option v-for="item in data.aksi" :key="item.aksi">{{
                      item.aksi
                    }}</a-select-option>
                  </a-select>
                </a-form-item>
                <a-form-item :wrapper-col="{ span: 24 }">
                  <a-button
                    @click="handleAction"
                    block
                    type="primary"
                    html-type="submit"
                    >Save</a-button
                  >
                </a-form-item>
              </a-form>
            </a-card>
          </a-col>
        </a-row>
      </div>
      <a-modal v-model="visibleHistory" @ok="historyToggle" :footer="null">
        <span slot="title"> <a-icon type="reload" />&nbsp;History Status </span>
  
        <ul class="m-list-wrapper bordered">
          <li v-for="history in data.history" :key="history.id_notifikasi">
            <div v-if="history.aksi === '1' || history.aksi === '3'">
              <div class="m-display-flex space-between">
                <h3 class="margin-remove m-list-title">
                  {{ history.as_from }}
                  {{ history.tlc_from ? "|" + history.tlc_from : "" }}
                </h3>
                <Status :status="history.deskripsi" />
              </div>
              <span class="m-list-desc">{{ history.tgl_notif }}</span>
            </div>
            <div v-else-if="history.aksi === '2' || history.aksi === '4'">
              <div class="m-display-flex space-between">
                <h3
                  class="margin-remove m-list-title"
                  v-if="history.aksi === '4' && history.deskripsi === 'Edited'"
                >
                  {{ history.as_from }}
                  {{ history.tlc_from ? "|" + history.tlc_from : "" }}
                </h3>
                <h3 class="margin-remove m-list-title" v-else>
                  {{ history.as_to }}
                  {{ history.tlc_to ? "|" + history.tlc_to : "" }}
                </h3>
                <Status :status="history.deskripsi" />
              </div>
              <span class="m-list-desc">{{ history.tgl_notif }}</span>
            </div>
          </li>
        </ul>
      </a-modal>
      <a-drawer
        title="Security"
        placement="bottom"
        :closable="true"
        @close="onClose"
        :visible="securityVisible"
      >
        <a-form :form="formConfirm">
          <a-form-item label="TLC">
            <a-input
              type="text"
              placeholder="TLC"
              v-decorator="['tlc_user', { rules: [{ required: true }], initialValue: data.tlc_user }]"
            />
          </a-form-item>
          <a-form-item label="Password">
            <a-input
              type="password"
              placeholder="Password"
              v-decorator="['password', { rules: [{ required: true }] }]"
            />
          </a-form-item>
          <a-form-item :wrapper-col="{ span: 24 }">
            <a-button
              @click="handleSubmit"
              block
              type="primary"
              html-type="submit"
              >Proses</a-button
            >
          </a-form-item>
        </a-form>
      </a-drawer>
    </div>
  </template>
  
  <script>
  import axios from "axios";
  import Status from "@/components/Status.vue";
  import { mapGetters } from "vuex";
  import CurrencyFormat from "@/mixins/CurrencyFormat";
  import moment from "moment";
  import _ from "lodash";
import { initial } from "lodash";
  
  export default {
    name: "PuManifestKK",
    props: ["id"],
    components: { Status },
    mixins: [CurrencyFormat],
    data() {
      return {
        currency: "",
        visibleHistory: false,
        securityVisible: false,
        pageLoading: true,
        search: "",
        data: {},
        submit: {},
        tableData: [],
        pagination: {
          onChange: (page) => {
            this.pagination.page = page;
          },
          page:1,
          pageSize: 5,
          size: "small",
        },
        loading: {
          savepetenrialtaxid: "",
          savepetenrialtax: false,
        },
      };
    },
    beforeCreate() {
      this.form = this.$form.createForm(this);
      this.formConfirm = this.$form.createForm(this);
    },
    created() {
      this.fetchManifest();
    },
    computed: {
      ...mapGetters(["getScreen", "getDefaultDateFormat"]),
      columns() {
        let { sortedInfo, filteredInfo } = this;
        sortedInfo = sortedInfo || {};
        filteredInfo = filteredInfo || {};
  
        const kolom = [
          {
            title: "No",
            dataIndex: "no",
            key: "no",
            width: 59,
            sorter: (a, b) => a.no - b.no,
          },
          {
            title: "Date",
            dataIndex: "report_date",
            width: 100,
            key: "report_date",
            sorter: (a, b) =>
              new Date(
                moment(a.report_date, this.getDefaultDateFormat).format(
                  this.getStandartFormatDate
                )
              ) -
              new Date(
                moment(b.tanggal, this.getDefaultDateFormat).format(
                  this.getStandartFormatDate
                )
              ),
          },
          {
            title: "Description",
            key: "deskripsi",
            width: 200,
            sorter: (a, b) => a.deskripsi.length - b.deskripsi.length,
            scopedSlots: { customRender: "deskripsi" },
          },
          {
            title: "Document",
            key: "document",
            scopedSlots: { customRender: "document" },
            width: 150,
            align: "center"
          },
          {
            title: "SPPD No.",
            key: "no_sppd",
            width: 200,
            sorter: (a, b) => a.no_sppd.length - b.no_sppd.length,
            scopedSlots: { customRender: "no_sppd" },
          },
          {
            title: "End User",
            key: "end_user_nm",
            width: 200,
            sorter: (a, b) => a.end_user_nm - b.end_user_nm,
            scopedSlots: { customRender: "end_user_nm" },
          },
          {
            title: "Credit",
            dataIndex: "kredit",
            key: "kredit",
            width: 100,
            sorter: (a, b) => a.kredit.length - b.kredit.length,
            scopedSlots: { customRender: "kredit" },
          },
        ];
        return kolom;
      },
      searching() {
        if (this.search) {
          this.tableData = this.data.detail_invoice;
          this.tableData = this.tableData.filter(
            (obj) =>
              obj.description.toLowerCase().indexOf(this.search.toLowerCase()) >=
                0 ||
              moment(obj.report_date, "DD-MM-YYYY")
                .format("DD-MM-YYYY")
                .toString()
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) >= 0
          );
        }
  
        if (!this.search) {
          this.tableData = this.data.detail_invoice;
        }
  
        return this.tableData;
      },
    },
    methods: {
      moment,
      fetchManifest() {
        axios({
          method: "get",
          url: this.$serviceUrl + "Public_manifest/manifest_klaim_tiket",
          params: {
            id: this.id,
          },
        })
          .then((response) => {
            this.data = {
              header: {
                no_klaim: response.data.invoice[0].no_transaksi,
                tanggal_buat: response.data.invoice[0].report_date,
                user_pelapor: response.data.invoice[0].nama,
                total_klaim: response.data.invoice[0].total || 0,
                user_cc: response.data.invoice[0].user_cc,
                note: response.data.invoice[0].note
              },
              jenis: response.data.jenis,
              last_status: response.data.invoice[0].status,
              user_pembuat: {
                tlc: response.data.invoice[0].tlc,
                tanggal: response.data.invoice[0].tgl_buat,
                status: "Created",
              },
              bukti_transfer: response.data.detail_bukti_transfer,
              detail_invoice: response.data.dtl_invoice,
              status: response.data.status_app,
              history: response.data.notifikasi,
              aksi: response.data.aksi,
              tlc_user: response.data.tlc ? response.data.tlc : ''
            };
  
            for (let i = 0; i < this.data.detail_invoice.length; i++) {
              this.data.detail_invoice[i]["potential_tax"] = this.data.detail_invoice[i].potensial_tax=="1"?true:false;
              this.data.detail_invoice[i]['key'] = i + 1;
              this.data.detail_invoice[i]["no"] = i + 1;
              this.data.detail_invoice[i]["kredit"] = {
                curr: 'IDR',
                val: Number(this.data.detail_invoice[i].credit),
              };
              this.data.detail_invoice[i]["report_date"] = moment(this.data.detail_invoice[i].report_date).format(
                this.getDefaultDateFormat
              );

            }
            this.pageLoading = false;
          })
          .catch((err) => {
            if (err.response.status === 404) {
              this.displayMessage("404");
            }
            this.pageLoading = false;
            // this.$router.go(-1);
          });
      },
      historyToggle(e) {
        e.stopPropagation();
        this.visibleHistory = !this.visibleHistory;
      },
      handlePrint() {},
      handleAction() {
        this.form.validateFields((err, values) => {
          if (err) {
            this.displayMessage("choose-action");
            return;
          }
          this.submit = {
            catatan: values.catatan ? values.catatan : "",
            aksi: values.aksi,
          };
          this.securityVisible = true;
          this.$nextTick(() => {
            this.formConfirm.setFieldsValue({
              tlc_user: this.data.tlc_user
            });
          });
        });
      },
      handleSubmit() {
        this.formConfirm.validateFields( async (err, values) => {
          if (err) {
            this.displayMessage("choose-action");
            return;
          }
  
          let postData = new FormData();
  
          postData.append("id_manifest", this.id);
          postData.append("status", this.submit.aksi);
          postData.append(
            "remark",
            this.submit.catatan !== undefined ? this.submit.catatan : ""
          );
          postData.append("password", values.password);
          postData.append("tlc", values.tlc_user);
  
          await axios({
            method: "post",
            url: this.$serviceUrl + "Public_manifest/approval_klaim_tiket",
            processData: false,
            data: postData,
          }).then((response) => {
            this.displayMessage("success");
            this.$router.go();
          }).catch((err) => {
            this.displayMessageValue("error", err.response.data.message);
          });
        });
      },
      onClose() {
        this.securityVisible = false;
      },
      handleCheckData(item) {
        let indx = _.findIndex(
          this.data.detail_invoice,
          (el) => el.key == item.key
        );
        this.data.detail_invoice[indx].potensial_tax = null;
        this.data.detail_invoice[indx].reason_potensial = "";
        this.data.detail_invoice[indx].potential_tax = !this.data.detail_invoice[
          indx
        ].potential_tax;
        if (this.data.detail_invoice[indx].potential_tax) {
          document.getElementById("div_" + item.key).style = "display:block";
          document.getElementById("button_" + item.key).style = "display:block";
        } else {
          document.getElementById("div_" + item.key).style = "display:none";
          document.getElementById("button_" + item.key).style = "display:none";
          document.getElementById("note_" + item.key).value = "";
        }
  
        if(!this.data.detail_invoice[indx].potential_tax){
          let formData = new FormData();
          formData.append("jenis_transaksi", this.data.detail_invoice[indx].jenis_transaksi);
          formData.append("id_dtl", this.data.detail_invoice[indx].id_dtl);
          formData.append("potential_tax", "0");
          formData.append("note", "");
          this.$store
            .dispatch("axiosStorePublicPost", {
              url: "Public_manifest/tax_potential",
              params: formData,
            })
            .then(() => {
            })
            .catch((err) => {
              console.log("err", err);
              let responses = Object.assign({}, err.response);
              this.displayMessageValue("error", responses);
            });
        }
      },
      submitPotentialTax(item) {
        this.loading.savepetenrialtax = true;
        this.loading.savepetenrialtaxid = "div_" + item.key;
  
        let items = _.filter(
          this.data.detail_invoice,
          (el) => el.key == item.key
        );
  
        if (items.length > 0 && items[0].reason_potensial != undefined) {
          let formData = new FormData();
          formData.append("jenis_transaksi", items[0].jenis_transaksi);
          formData.append("id_dtl", items[0].id_dtl);
          formData.append("potential_tax", items[0].potential_tax ? "1" : "0");
          formData.append("note", items[0].reason_potensial);
          this.$store
            .dispatch("axiosStorePublicPost", {
              url: "Public_manifest/tax_potential",
              params: formData,
            })
            .then((res) => {
              let ind = _.findIndex(this.data.detail_invoice, { key: item.key });
              this.data.detail_invoice[ind].id_dtl = res.data.id_dtl;
              this.data.detail_invoice[ind].reason_potensial = res.data.note;
              this.data.detail_invoice[ind].potensial_tax = res.data.potential_tax;
              this.loading.savepetenrialtax = false;
              this.loading.savepetenrialtaxid = "";
            })
            .catch((err) => {
              console.log("err", err);
              this.loading.savepetenrialtax = false;
              this.loading.savepetenrialtaxid = "";
              let responses = Object.assign({}, err.response);
              this.displayMessageValue("error", responses);
            });
        } else {
          this.displayMessageValue(
            "error-other",
            "Data Not Selected or Note is empty!"
          );
          this.loading.savepetenrialtax = false;
          this.loading.savepetenrialtaxid = "";
        }
      },
      viewlampiranDoc(url) {
        window.open(this.$serviceUrl + url, "_blank");
      },
    },
  };
  </script>
  
  <style>
  </style> 